import LessonPrep from './component'
export default LessonPrep
